import { render, staticRenderFns } from "./ImageFullWidth.vue?vue&type=template&id=b4c04c44&"
import script from "./ImageFullWidth.vue?vue&type=script&lang=js&"
export * from "./ImageFullWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports